import { useEffect } from 'react';

/**
 * Atualiza o favicon da página via <link rel="icon">.
 * Evita o uso de react-favicon e o warning de defaultProps.
 * @param {string} url - URL do ícone (ex: favicon.ico ou imagem)
 */
const FaviconUpdater = ({ url }) => {
  useEffect(() => {
    if (!url) return;
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = url;
  }, [url]);
  return null;
};

export default FaviconUpdater;
